import React from 'react';
import ReactDOM from 'react-dom';

import { useSelector, useDispatch } from "react-redux";
import { createAccount, updateAccount } from "../../actions/account";
import { useNavigate } from 'react-router-dom';
import { isNotNull, loginByUniId } from '../../common/utils';
import { yellow } from '@mui/material/colors';
import { BsArrowBarLeft } from "react-icons/bs";
import { purgeData, store } from '../..';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/img/LogoUwin.png'
import { restPostApi } from '../../services/httpService';
import { loadAccountInfoUrl, registerByOtpUrl } from '../../common/url';
import { setDataFromModal, setDataToModal } from '../../actions/modal';
import { success } from '../../common/errorCode';
import { httpSuccess } from '../../common/errorCode';
import { error } from '../../common/errorCode';

const AccountPage = () => {

    const navigate = useNavigate();
    const [accountRedux, setAccount] = React.useState({ "accountUser": { "msisdn": "" } });
    const [regInfosRedux, setRegInfos] = React.useState({});
    const [selectedLanguage, setSelectedLanguage] = React.useState("la");
    const { t } = useTranslation();
    const tokenInfo = useSelector((state) => state.SessionReducer);

    const account = useSelector((state) => state.AccountReducer);
    const dispatch = useDispatch();
    
    console.log("account: " + JSON.stringify(account));

    React.useEffect(() => {
        console.log("ACCOUNT SCREEN");
        // load account again
        loadAccountInfo();


        // if (!isNotNull(account) || !isNotNull(account.accountUser) || !isNotNull(account.accountUser.msisdn)) {
        //     console.log("TO LOGIN");
        //     navigate('/flash', { replace: true });
        // } else {
        //     console.log("msisdn: " + account.accountUser.msisdn);
        // }

        // if (isNotNull(account) && isNotNull(account.regInfos) && account.regInfos.length > 0) {
        //     console.log("package: " + account.regInfos[0].packageName);
        //     setRegInfos(account.regInfos)
        // }

        // packageName = isNotNull(account.regInfos) && account.regInfos.count > 0 ?
        //     account.regInfos[0].packageName : "NOT REGISTER";
        // dateRegister = isNotNull(account.regInfos) && account.regInfos.count > 0 ?
        //     account.regInfos[0].registerTime : "NOT REGISTER"

        // setAccount(account);

    }, []);

    async function loadAccountInfo() {
        let res = await restPostApi(
            loadAccountInfoUrl,
            {},
            tokenInfo
        );

        console.log("res: " + JSON.stringify(res));

        if (res != null) {
            console.log("status: " + res.status);

            let errorCode = error;
            let message = "ERROR";
            if (res.status === httpSuccess) {
                console.log("errorCode: " + res.data.errorCode);
                errorCode = res.data.errorCode;
                if (res.data.errorCode === success) {
                    // create account
                    let accountInfo = {
                        accountUser: res.data.data.accountUser,
                        regInfos: res.data.data.regInfos
                    };
                    dispatch(updateAccount(accountInfo));

                    setRegInfos(res.data.data.regInfos)
                    setAccount(accountInfo);
                    return;
                } else {
                    console.log("message: " + res.data.message);
                    message = res.data.message;
                }
            }
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: errorCode,
                    message: message
                }
            }));
        }
    }

    function logoutClick() {
        console.log("LOG OUT");
        purgeData();
        loginByUniId();
    }

    function chooseLanguage(lang) {
        console.log("change language to: " + lang);
        i18n.changeLanguage(lang);
        setSelectedLanguage(lang);
    }

    return (
        <div className="content">
            <div className="w-full h-full flex justify-center items-center">
                <div className="flex flex-col w-full">
                    <div className="max-w-[150px] w-full h-[150px] rounded-[50%] mx-auto"
                        style={{ boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)", overflow: "hidden" }}>
                        <img src={logo} />
                    </div>
                    <div className="py-2 flex justify-center items-center">
                        <span className="phone_account">{accountRedux.accountUser.msisdn}</span>
                    </div>
                    <div className="max-w-[280px] w-full py-2 mx-auto">
                        <div className="py-2" style={{ borderBottom: "1px solid #FFFFFF" }}>
                            <div className="flex justify-between w-full">
                                <div className="text-c-1 font-z-15">
                                    {t("totalTurn")}
                                </div>
                                <div className="text-c-6 font-z-14">
                                    {accountRedux.accountUser.totalTurns}
                                </div>
                            </div>
                        </div>
                        <div className="py-2" style={{ borderBottom: "1px solid #FFFFFF" }}>
                            <div className="flex justify-between w-full">
                                <div className="text-c-1 font-z-15">
                                    {t("account")}
                                </div>
                                <div className="text-c-6 font-z-14">
                                    {isNotNull(regInfosRedux) && regInfosRedux.length > 0 ? regInfosRedux[0].isActive : t("inactive")}
                                </div>
                            </div>
                        </div>
                        <div className="py-2" style={{ borderBottom: "1px solid #FFFFFF" }}>
                            <div className="flex justify-between w-full">
                                <div className="text-c-1 font-z-15">
                                    {t("subscriber")}
                                </div>
                                <div className="text-c-6 font-z-14">
                                    {isNotNull(regInfosRedux) && regInfosRedux.length > 0 ? regInfosRedux[0].packageName : t("notRegister")}
                                </div>
                            </div>
                        </div>
                        <div className="py-2" style={{ borderBottom: "1px solid #FFFFFF" }}>
                            <div className="flex justify-between w-full">
                                <div className="text-c-1 font-z-15">
                                    {t("dateOfSubscriber")}
                                </div>
                                <div className="text-c-6 font-z-14">
                                    {
                                        (() => {
                                            let data = "NOT REGISTER";
                                            if (isNotNull(regInfosRedux) && regInfosRedux.length > 0) {
                                                let day = regInfosRedux[0].registerTime[2];
                                                let month = regInfosRedux[0].registerTime[1];
                                                let year = regInfosRedux[0].registerTime[0];
                                                data = day + "-" + month + "-" + year;
                                                data = regInfosRedux[0].registerTime.split(" ")[0];
                                            }
                                            return data;
                                        })()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="py-2" style={{ borderBottom: "1px solid #FFFFFF" }}>
                            <div className="flex justify-between w-full">
                                <div className="text-c-1 font-z-15">
                                    {t("languages")}
                                </div>
                                <div className="text-c-6 font-z-14">
                                    <div className="flex justify-center flag-container" style={{ margin: "0px" }}>
                                        <div className="text-c-2 font-z-18 flag-style"
                                            onClick={() => chooseLanguage('en')}>
                                            <img src='../assets/images/en_flag.png' />
                                        </div>
                                        <div className="text-c-2 font-z-18 flag-style" style={{ marginRight: "0px" }}
                                            onClick={() => chooseLanguage('la')}>
                                            <img src='../assets/images/laos_flag.png' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="py-2" onClick={logoutClick}>
                            <div className="flex justify-between w-full">
                                <div className="text-c-1 font-z-15">
                                    <BsArrowBarLeft style={{ height: "2rem", width: "2rem" }} />
                                    {t("logout")}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default AccountPage;